(function() {
  'use strict';

  angular.module('component.relations', []);
})();
